/*
    This file is used to extract complexities away from the main UI code, like linking to the Redux
    store and theming common components.
*/

import React from "react";
import { Provider } from "react-redux";

import store from "state/store";
import App from "ui/App";

const AppWrapper: React.FC = () => (
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

export default AppWrapper;
